<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <div style="padding: 16px 32px 16px 0px">
              <span class="title">校友会管理</span>
              <el-button type="primary" size="small" style="float: right" @click="addAssociation()" v-if="isAssociationAdmin == 'N'">新建</el-button>
            </div>
            <div class="aLine"></div>
            <!-- 搜索和筛选区域 -->
            <div style="padding: 16px 32px; background: #fafafa;">
              <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="搜索">
                  <el-input
                    v-model="searchForm.search"
                    placeholder="请输入校友会名称"
                    clearable
                    @keyup.enter.native="handleSearch"
                  ></el-input>
                </el-form-item>
                <el-form-item label="后台分类">
                  <el-select
                    v-model="searchForm.screen_bType"
                    placeholder="请选择分类"
                    clearable
                    @change="handleSearch"
                  >
                    <el-option
                      v-for="item in bTypeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleSearch">查询</el-button>
                  <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="aLine"></div>
            <el-row :gutter="24" justify="center" style="margin-top: 10px">
              <el-col :span="6" v-for="item in data_list" :key="item.id" :offset="0" style="margin-bottom: 23px">
                <el-card
                  :body-style="{
                    padding: '0px'
                  }"
                >
                  <div @click="toDetails(item)" style="cursor: pointer">
                    <el-image
                      ref="elCardImg"
                      fit="scale-down"
                      :src="urlPath + item.thumb"
                      v-bind:style="{
                        width: '100%',
                        height: '169px',
                        display: 'block'
                      }"
                    >
                      <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <div class="footDiv">
                      <p class="title1">{{ item.title }}</p>
                      <p class="title2">{{ item.abstract }}</p>
                      <div class="bottomDiv">
                        <time class="updateTime">{{ item.createTime }}</time>
                        <!-- <div class="avatar-list-stacked">
                      <span
                        class="avatar"
                        style="
                          background: url('/logo.png') center center;
                          background-repeat: no-repeat;
                          background-size: cover;
                          background-position: 0px 0px;
                        "
                      ></span>
                      <span
                        class="avatar"
                        style="
                          background: url('/logo.png') center center;
                          background-repeat: no-repeat;
                          background-size: cover;
                          background-position: 0px 0px;
                        "
                      ></span>
                      <span
                        class="avatar"
                        style="
                          background: url('/logo.png') center center;
                          background-repeat: no-repeat;
                          background-size: cover;
                          background-position: 0px 0px;
                        "
                      ></span>
                    </div> -->
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-pagination
              :key="elementui_page_key"
              class="elPagination"
              background
              layout="prev, pager, next"
              :page-size="pageMaxSize"
              :page-count="pageCount"
              :current-page="currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      urlPath: URL_PATH,
      updateTime: '上次更新的时间',
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      isAssociationAdmin: 'Y',
      searchForm: {
        search: '',
        screen_bType: ''
      },
      bTypeOptions: [] // 后台分类选项
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.meunIndex = this.meunItem.index
      localStorage.setItem(this.meunIndex, '')
      this.getList()
    },
    // 是否是校友分会长
    associationAdmin: function () {
      this.$api
        .isAssociationAdmin({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.isAssociationAdmin = data.Data.isAssociationAdmin
        })
        .catch(({ error }) => {})
    },
    // 获取列表
    getList: function () {
      this.associationAdmin()
      const params = {
        token: localStorage.getItem('token'),
        page: this.currentPage,
        limit: this.pageMaxSize
      }
      // 添加搜索参数
      if (this.searchForm.search) {
        params.search = this.searchForm.search
      }
      if (this.searchForm.screen_bType) {
        params.screen_bType = this.searchForm.screen_bType
      }

      this.$api
        .associationList(params)
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.bTypeOptions = data.Data.bType || [] // 设置后台分类选项
          this.data_list.forEach(info => {
            info.createTime = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 跳转到详情
    toDetails(item) {
      localStorage.setItem('association_tab', '0')
      this.$router.push({
        path: '/wxapp/association',
        query: {
          id: item.id,
          title: item.title
        }
      })
    },
    // 新建校友会
    addAssociation() {
      this.$router.push({
        path: '/wxapp/association_add'
      })
    },
    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        search: '',
        screen_bType: ''
      }
      this.currentPage = 1
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #474747;
  overflow: hidden; /*溢出的部分隐藏*/
  white-space: nowrap; /*文本不换行*/
  text-overflow: ellipsis; /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
}
.title2 {
  margin-top: 4px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #595959;
  overflow: hidden; /*溢出的部分隐藏*/
  white-space: nowrap; /*文本不换行*/
  text-overflow: ellipsis; /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
}

.updateTime {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12.48px;
  line-height: 21px;
  color: #8c8c8c;
}
.footDiv {
  padding: 16px 24px 24px 24px;
}
.bottomDiv {
  margin-top: 8px;
}
.avatars {
  float: right;
  width: 30px;
  height: 30px;
}
.image {
  width: 100%;
  height: 169px;
  display: block;
}
.avatar-list-stacked .avatar {
  float: right;
  box-shadow: 0 0 0 1px #fff;
}
.avatar-list-stacked .avatar {
  margin-right: -1.9em !important;
}
.avatar {
  width: 30px;
  height: 30px;
  line-height: 20rem;
  display: inline-block;
  background: #2ddcd3 no-repeat center/cover;
  position: relative;
  text-align: center;
  color: #fff;
  font-weight: 600;
  vertical-align: bottom;
  font-size: 0.875rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/associationList.vue